module.exports = __webpack_public_path__ + "static/img/cloud-left_bottom.1f3ddbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-left_bottom.png
// module id = 657
// module chunks = 64